import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';

const FrequencyView = (props) => {
    const {
        points,
        frequencyUnitSymbol,
        magnitudeUnitSymbol,
        precision
    } = props;
    const [frequency, timestamp, magnitude, originalMagnitude] = points;
    const displayMagnitude = originalMagnitude !== undefined ? originalMagnitude : magnitude;
    return (
        <div className='frequency-view-tooltip'>
            <div className='timestamp'>
                {timestamp}
            </div>
            <div className='divider' />
            <div className='magnitude'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartZAxisText')}:</span>
                <span>{displayMagnitude.toFixed(precision)} {magnitudeUnitSymbol}</span>
            </div>
            <div className='frequency'>
                <span>{translate('ABB.Powertrain.Frontend.fftEchartXAxisText')}:</span>
                <span>{frequency.toFixed(precision)} {frequencyUnitSymbol}</span>
            </div>
        </div>
    );
};

FrequencyView.propTypes = {
    points: PropTypes.arrayOf(PropTypes.number).isRequired,
    frequencyUnitSymbol: PropTypes.string,
    magnitudeUnitSymbol: PropTypes.string,
    precision: PropTypes.number
};

FrequencyView.defaultProps = {
    frequencyUnitSymbol: 'Hz',
    magnitudeUnitSymbol: '',
    precision: 2
};

export default FrequencyView;
